type GlobalProcess = {
  env?: Record<string, string>;
};

const getImportMetaEnv = (): Record<string, unknown> => {
  return (import.meta as { env?: Record<string, unknown> }).env ?? {};
};

const getStringEnv = (
  inputEnv: Record<string, unknown>,
): Record<string, string> => {
  const envEntries = Object.entries(inputEnv).filter(
    (entry): entry is [string, string] => typeof entry[1] === "string",
  );

  return envEntries.reduce<Record<string, string>>((acc, [key, value]) => {
    acc[key] = value;
    return acc;
  }, {});
};

const getGlobalProcessWithEnv = (): Required<GlobalProcess> => {
  const existing = Reflect.get(globalThis, "process") as
    | GlobalProcess
    | undefined;
  if (existing?.env != null) {
    return existing as Required<GlobalProcess>;
  }

  const processRef = { ...existing, env: {} };
  Reflect.set(globalThis, "process", processRef);
  return processRef;
};

export const ensureProcessEnvFromImportMeta = (): void => {
  const env = getStringEnv(getImportMetaEnv());
  if (Object.keys(env).length === 0) {
    return;
  }

  Object.assign(getGlobalProcessWithEnv().env, env);
};

ensureProcessEnvFromImportMeta();
